export default __webpack_public_path__ + "static/pic2-5026d9baad3c1f3cda7288c4a800d34f.png";